module.exports = "https://coursera_assets.s3.amazonaws.com/images/ed63e16515110347149a370daa1db9c3.png";